import { Controller } from "@hotwired/stimulus"

// Toggles the visibility of "extra" session cards on the seniors landing page.
// By default Super / Deluxe / Standard show; Basic / Economy hide behind a
// "See more sessions" toggle that flips this controller's `expanded` state.
export default class extends Controller {
  static targets = ["extra", "label"]
  static values = { expanded: { type: Boolean, default: false } }

  toggle() {
    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged() {
    this.extraTargets.forEach(el => { el.hidden = !this.expandedValue })

    this.element.classList.toggle("seniors-packages--expanded", this.expandedValue)

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.expandedValue
        ? "Show fewer sessions"
        : "See more sessions"
    }

    const button = this.element.querySelector("[data-action~='seniors-packages#toggle']")
    if (button) button.setAttribute("aria-expanded", this.expandedValue.toString())
  }
}
